import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appNoSpecialChars]',
  standalone: true
})
export class NoSpecialCharsDirective {

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    const initialValue = this.el.nativeElement.value;

    // First, replace spaces with underscores
    let newValue = initialValue.replace(/\s+/g, '_');

    // Then, remove special characters except for underscores
    newValue = newValue.replace(/[^a-zA-Z0-9_]/g, '');

    this.el.nativeElement.value = newValue;

    if (initialValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
